import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ago } from "@/lib/format";
import { cn } from "@/lib/utils";
import { PageHeader } from "@/components/shell/PageHeader";
import { Panel, ProvenanceTag, TableSkeleton } from "@/components/common/primitives";
import { Eye, Bell, AlertTriangle } from "lucide-react";

export function Watchlists() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.watchlists().then((r) => setRows(r.data)); }, []);
  if (!rows) return <TableSkeleton rows={3} />;
  return (
    <div className="space-y-4">
      <PageHeader title="Watchlists" description="Scheduled refresh and freshness monitoring build first-party history." meta={<ProvenanceTag kind="fixture" />} />
      <div className="grid md:grid-cols-2 gap-3">
        {rows.map((w) => (
          <Panel key={w.id} className="p-4" testid={`watchlist-${w.id}`}>
            <div className="flex items-center justify-between">
              <span className="text-stitle text-ink-primary flex items-center gap-2"><Eye className="h-4 w-4" />{w.name}</span>
              <span className="text-micro font-mono text-ink-muted">{w.items} items</span>
            </div>
            <div className="text-micro font-mono text-ink-muted mt-2">Last refresh {ago(w.last_refresh)}</div>
          </Panel>
        ))}
      </div>
    </div>
  );
}

const SEV = { critical: "text-red-600", moderate: "text-amber-600", info: "text-ink-muted" };
export function Alerts() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.alerts().then((r) => setRows(r.data)); }, []);
  if (!rows) return <TableSkeleton rows={4} />;
  return (
    <div className="space-y-4">
      <PageHeader title="Alerts" description="Alert rules, in-app / email notifications and freshness monitoring." meta={<ProvenanceTag kind="fixture" />} />
      <Panel className="p-0 overflow-hidden">
        {rows.map((a) => (
          <div key={a.id} className="flex items-center gap-3 p-3 border-b border-edge-subtle last:border-0 hover:bg-surface-2" data-testid={`alert-${a.id}`}>
            <AlertTriangle className={cn("h-4 w-4", SEV[a.severity])} />
            <div className="flex-1 min-w-0"><div className="text-compact text-ink-primary">{a.rule}</div><div className="text-micro text-ink-muted">{a.product}</div></div>
            <span className="text-micro font-mono text-ink-muted">{ago(a.at)}</span>
          </div>
        ))}
      </Panel>
    </div>
  );
}
